import { ReactNode, useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { Box, RowsSkeletonLoader } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { earnDetailsBreadcrumbAtom } from '../atoms/breadcrumbAtom'
import {
  EARN_DETAILS_STATE,
  EarnDetailsLifecycleState,
  EarnDetailsReady,
} from '../types/detailsState'
import { EarnDetailsHeader } from './EarnDetailsHeader'
import { EarnHistory } from './history/EarnHistory'

export interface EarnDetailsLayoutProps {
  portfolioId: string | undefined
  viewData: EarnDetailsLifecycleState | EarnDetailsReady
  children: ReactNode
}

export const EarnDetailsLayout = ({ portfolioId, viewData, children }: EarnDetailsLayoutProps) => {
  const navigate = useNavigate()
  const setEarnDetailsBreadcrumb = useSetAtom(earnDetailsBreadcrumbAtom)

  useEffect(() => {
    setEarnDetailsBreadcrumb(
      viewData.detailsState === EARN_DETAILS_STATE.READY ? viewData.asset : ''
    )
    return () => setEarnDetailsBreadcrumb('')
  }, [viewData, setEarnDetailsBreadcrumb])

  if (viewData.detailsState === EARN_DETAILS_STATE.LOADING) {
    return <RowsSkeletonLoader rows={10} />
  }

  if (viewData.detailsState === EARN_DETAILS_STATE.NOT_FOUND) {
    navigate(PathNames.NOT_FOUND)
    return null
  }

  return (
    <>
      <EarnDetailsHeader
        asset={viewData.asset}
        onWithdrawClick={viewData.onWithdraw}
        onDepositClick={viewData.onDeposit}
      />
      <Box flexCol gap={24}>
        {children}
        <EarnHistory portfolioId={portfolioId} walletId={viewData.walletId} />
      </Box>
    </>
  )
}
